import { type FC } from "react";

import { SymbolIcon } from "widgets";

import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import TableCellText from "./core/TableCellText.js";
import { STRAND_TYPE } from "@/settings/settings.js";

export const getStrandDisplayValue = (strand: string) => {
  let color: string;
  let icon = "question_mark";

  switch (strand) {
    case STRAND_TYPE.PLUS:
      color = "#7CB54E";
      icon = "add";
      break;
    case STRAND_TYPE.MINUS:
      color = "#B5183F";
      icon = "remove";
      break;
  }

  return <SymbolIcon icon={icon} style={{ color }} />;
};

const StrandCell: FC<IAgGridCellProps> = (props) => {
  const strand: string = props.value;

  if (!strand) {
    return null;
  }

  return <TableCellText {...props} valueFormatted={getStrandDisplayValue(strand)} />;
};

export default StrandCell;
